import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CoffeeSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.2218 9.01565C17.5169 9.5676 18.9241 10.4576 18.9241 11.4085C18.9241 12.974 15.0359 14.3804 9.99351 14.3804C4.96109 14.3804 1.076 12.974 1.076 11.4085C1.076 10.4645 2.44258 9.58829 4.71799 9.02324L4.18032 8.03926C1.56611 8.74388 0 9.94228 0 11.4085C0 13.7984 4.17013 15.4495 9.99351 15.4495C15.8368 15.4495 20 13.7984 20 11.4085C20 9.91091 18.3582 8.68184 15.6553 7.9872L15.2218 9.01565ZM15.8985 3.68878V5.29374C15.8985 8.70052 13.7668 11.012 10.3281 11.012H9.65888C6.21404 11.012 4.09851 8.71051 4.09851 5.29374V3.68878H2.98802V5.29374C2.98802 9.30402 5.61363 12.1294 9.65888 12.1294H10.3281C14.3803 12.1294 17.009 9.30402 17.009 5.29374V3.68878H15.8985ZM9.99351 6.83397C14.1595 6.83397 17.009 5.54844 17.009 3.68878C17.009 1.83602 14.1664 0.550476 9.99351 0.550476C5.82366 0.550476 2.98802 1.83602 2.98802 3.68878C2.98802 5.54844 5.83056 6.83397 9.99351 6.83397ZM9.99351 5.72348C6.58814 5.72348 4.09851 4.83602 4.09851 3.68878C4.09851 2.54533 6.58814 1.66096 9.99351 1.66096C13.4089 1.66096 15.8985 2.54533 15.8985 3.68878C15.8985 4.83602 13.4089 5.72348 9.99351 5.72348ZM16.1734 8.57713H16.8159C18.5377 8.57713 19.5856 7.65059 19.5856 6.13825C19.5856 4.64279 18.531 3.71627 16.8159 3.71627H16.3706V4.82364H16.8159C17.8492 4.82364 18.4782 5.32451 18.4782 6.13825C18.4782 6.96196 17.8492 7.46973 16.8159 7.46973H16.1734V8.57713Z"
        fill={color}
      />
    </svg>
  );
};

export { CoffeeSvg };
